/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/atan2.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * The angle between the positive x-axis and the ray from the
 * origin to the point (x , y) in the Cartesian plane, expressed in radians.
 *
 * @example
 * ROW y=12.9, x=.6
 * | EVAL atan2=ATAN2(y, x)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'atan2',
  signatures: [
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'double',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'double',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'double',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'double',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'integer',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'integer',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'integer',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'integer',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'y_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'x_coordinate',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
